<template>
  <footer class="main-footer">
    &copy; 2022<a href="#"> Medmetic</a>. All Rights Reserved.
  </footer>
</template>